import { defineStore } from 'pinia'

export const useTestStore = defineStore('testStore', {
  state: () => ({
    version: '1.0.0',
    demo:true,
    testList: [''] as any,
    useToPath:'testPath'
  }),
  persist: process.client && {
    key: 'testStore',
    storage: persistedState.localStorage,
    beforeRestore: (ctx) => {
      // console.log(`即将恢复 '${ctx.store.$id}'`)
      // if (ctx.store.$id === 'testStore') {
      //   if (process.client) {
      //     if (
      //       window.location.pathname === '/' ||
      //       window.location.pathname.includes('/detail') ||
      //       window.location.pathname === '/launch'
      //     ) {
      //       window.localStorage.removeItem('testStore')
      //     }
      //   }
      // }
    },
    afterRestore: (ctx) => {
      // console.log(`恢复完成 '${ctx.store.$id}'`)
      // ctx.store.reInitAppDataAction()
    },
    paths: [
      'version',
      'testList',
    ]
  },
  actions: {

  },
  getters: {

  }
})
